export const WATER_CHARTS_INJECTION_KEY = Symbol('waterChartsInjectionKey');
